import type { ChatSurface } from './chat-surface-mappings';

let latestSurface: ChatSurface | null = null;
let polling = false;

export function setChatPageContext(surface: ChatSurface): void {
  latestSurface = surface;
  if (window.CarvanaChatUi?.setPageContext) {
    window.CarvanaChatUi.setPageContext(surface);
    return;
  }
  if (polling) return;
  polling = true;
  let attempts = 0;
  const timer = setInterval(() => {
    if (window.CarvanaChatUi?.setPageContext) {
      if (latestSurface) window.CarvanaChatUi.setPageContext(latestSurface);
    } else if (++attempts < 40) {
      return;
    }
    clearInterval(timer);
    polling = false;
  }, 200);
}
